import DeveloperTools from './DeveloperTools'
import withState from './withState'

export default withState(DeveloperTools)
